import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import IconFromStyle from '../StockItems/IconFromStyle';
import Button from '../ContentItems/Button';
import NavImage from '../ContentItems/NavImage';

function App(props) {

  var currentList = props.currentList;
  var itemEdited = props.itemEdited;
  var navBarPath = props.navBarPath;
  var navBarPathOrig = props.navBarPathOrig;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var interactionFn = props.interactionFn;
  var setItemEdited = props.setItemEdited;
  var error = props.error;
  var actHoveringWhere = props.actHoveringWhere;
  var hoveringWhere = props.hoveringWhere;
  var tabSelected = props.tabSelected;
  var changeTab = props.changeTab;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var flashHighlight = props.flashHighlight;
  var doAScreenRef = props.doAScreenRef;
  var chains = props.chains;
  var organicChanges = props.organicChanges;

  var thisNavRef = navBarPathOrig.join('_');
  var menu = internalVariables.otherInfo[thisNavRef];
  if (!menu){
    menu = false;
  }


  // const [menu, setMenu] = useState(false);

  function toggleMenu(e){
    internalVariables.otherInfo[thisNavRef] = !menu;
    internalVariables.setOtherInfo({...internalVariables.otherInfo})
    e.stopPropagation();
  }

  var upwardInfo = [];
  var errorString = CoreFns.errorString(error);
  var navObj = CoreFns.goDownPath(currentList, navBarPath, 0);

  var allStyles = StyleFunctions.evaluateStyleR('NAV', navObj.s, navBarPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

  StyleFunctions.modStyleWithFlashHighlight(allStyles, flashHighlight, navBarPath.join(' '));
  StyleFunctions.sortOutBackgroundColor(allStyles, navObj.s, navBarPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, false);


  var toChecks = ['navbarTextShade'];
  var className1 = StyleFunctions.iterateClassNames('navbar', toChecks, allStyles);
  var classNameHoverIn = StyleFunctions.iterateClassNames('', ['hoverEffect'], allStyles);
  var classNameHover = '';
  if (classNameHoverIn){
    classNameHover = ' ' + classNameHoverIn;
    // classNameHover = '  dropdownItem' + classNameHoverIn;
  }

  var title = 'Nav Bar';
  if (allStyles.navbarCluster){
    title = 'Left Cluster';
  }

  var navItemsLeft = doASet(organicChanges, navObj.i, 'i', interactionFn, upwardInfo, navBarPath, itemEdited, setItemEdited, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, errorString, hoveringWhere, actHoveringWhere, changeTab, tabSelected, isShowingSomeDropDown, title, false, classNameHover, doAScreenRef, flashHighlight);

  const show = (menu) ? 'show' : '' ;

  var buttonStyle = {borderColor:'black', color:allStyles.iconColor, border: "0"};
  var leftPiece;

  if (allStyles.navbarCluster){

    var navItemsCenter = doASet(organicChanges, navObj.ic, 'ic', interactionFn, upwardInfo, navBarPath, itemEdited, setItemEdited, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, errorString, hoveringWhere, actHoveringWhere, changeTab, tabSelected, isShowingSomeDropDown, 'Center Cluster', false, classNameHover, doAScreenRef, flashHighlight);
    var navItemsRight = doASet(organicChanges, navObj.ir, 'ir', interactionFn, upwardInfo, navBarPath, itemEdited, setItemEdited, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, errorString, hoveringWhere, actHoveringWhere, changeTab, tabSelected, isShowingSomeDropDown, 'Right Cluster', false, classNameHover, doAScreenRef, flashHighlight);

    if (width >= 768 || !allStyles.navbarCollapse){
      className1 += ' navbar-expand'
    }

    var restL = navItemsLeft.filter((aN, index)=>{return +index > 0});

    if (navItemsLeft.length > 0){
      leftPiece = navItemsLeft[0];
    }
                  // 
//
    allStyles.border = '1px solid black';

    return <nav className={className1} style={allStyles}>
                  {leftPiece}
                  <button className='navbar-toggler' onClick={ toggleMenu} style={buttonStyle}>
                      <IconFromStyle style={allStyles} iconColorPointer='menuIconColor'/>
                   </button>
                  <div className={'collapse navbar-collapse ' + show}>
                    <ul className='navbar-nav mr-auto w-100'>{restL}</ul>
                    <ul className='navbar-nav mx-auto w-100'>{navItemsCenter}</ul>
                    <ul className='navbar-nav ml-auto w-100 justify-content-end'>{navItemsRight}</ul>
                  </div>
              </nav>    
//
  }else{

    if (allStyles.navbarCollapse){
      if (width >= 768){
        className1 += ' navbar-expand'
      }

      var rest = navItemsLeft.filter((aN, index)=>{return +index > 0}).map((aN, index)=>{
        return <ul className="navbar-nav ml-auto">{aN}</ul>
      })
  //                       
      if (navItemsLeft.length > 0){
        leftPiece = navItemsLeft[0];
      }
  //
      return <nav className={className1} style={allStyles}>
                    {leftPiece}
                    <button className="navbar-toggler" onClick={ toggleMenu} style={buttonStyle}>
                        <IconFromStyle style={allStyles}  iconColorPointer='menuIconColor'/>
                     </button>
                    <div className={"collapse navbar-collapse " + show}>{rest}</div>
                </nav>    
    }else{
      return <nav className={className1} style={allStyles}>
                  {navItemsLeft}
              </nav>    
    }    
  }


//
}

function doASet(organicChanges, navBarItems, pointer, interactionFn, upwardInfo, navBarPath, itemEdited, setItemEdited, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, errorString, hoveringWhere, actHoveringWhere, changeTab, tabSelected, isShowingSomeDropDown, title, coverState, classNameHover, doAScreenRef, flashHighlight){

  function clickNavItem(anItemKey){
    return function(e){
      if (interactionFn){
        var aPossib = 'click';
        var thisItem = navBarItems[anItemKey];
        var ocSet = thisItem.oc;
        interactionFn(e, ocSet, aPossib, upwardInfo, navBarPath.concat([pointer, anItemKey, 'oc', aPossib]));
      }else{
        if (setItemEdited){
          setItemEdited({t:'item', path:navBarPath.concat([pointer, anItemKey])});
        }
        e.stopPropagation();
        CoreFns.clearSelection();
      }
    }
  }

  if (!navBarItems){
    navBarItems = {};
  }

  var sortedNavItemKeys = ResponsiveFns.sortAListBasedOnOrd(navBarItems);

  var navItems = sortedNavItemKeys.map((anItemKey, index)=>{
    var anItem = navBarItems[anItemKey];

    var thisItemPath = navBarPath.concat([pointer, anItemKey]);
    var allStyles1 = StyleFunctions.evaluateStyleR(anItem.t, anItem.s, thisItemPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

    if (interactionFn){
      StyleFunctions.addPointerIfGotClick(anItem, allStyles1);
    }
    var isError = false;

    var thisItemPathString = thisItemPath.join(' ');
    StyleFunctions.modStyleWithFlashHighlight(allStyles1, flashHighlight, thisItemPathString);    

    var i1;
    var editingClass = '';
    if (!interactionFn){
      if (itemEdited.t === 'item' && thisItemPathString === itemEdited.path.join(' ')){
        editingClass = ' editing';
      }else if (hoveringWhere === thisItemPathString){
        editingClass = ' preEditing';
      }else if (errorString){
        if (errorString.indexOf(thisItemPathString) === 0){
          editingClass = ' editingError';
          isError = true;
        }
      }
    }

    if (anItem.t === 'navBrand'){

      var srcPart;
      if (allStyles1.gotLogo){
        var logoWidth = allStyles1.logoWidth;
        if (!logoWidth){
          logoWidth = 100;
        }
        var thisStyle = {width:logoWidth};
        if (allStyles1.gotText){
          if (allStyles1.spacingGap){
            thisStyle.marginRight = allStyles1.spacingGap;
          }else{
            thisStyle.marginRight = '10px';
          }
        }
        var src = allStyles1.src;
        if (src){
          if (src.e){
            src = '';
          }
        }
        srcPart = <img src={src} style={thisStyle} alt='logo' ></img>
      }
//      

      var textPart;
      if (allStyles1.gotText){
        textPart = allStyles1.text
//
        // if (typeof textPart === 'object'){
        //   textPart = 'Error';
        // }

      }
      StyleFunctions.expandBIU(allStyles1);
      i1 = <span className={'navbar-brand' + editingClass} onMouseOver={actHoveringWhere(thisItemPathString)} onMouseOut={actHoveringWhere('')} style={allStyles1} onClick={clickNavItem(anItemKey)}>{srcPart}{textPart}</span>
//
    }else if (anItem.t === 'navLink'){
      var text2 = allStyles1.text;
      if (!text2){
        text2 = '';
      }else if (typeof text2 === 'object'){
        text2 = 'Error';
      }
      StyleFunctions.expandBIU(allStyles1);
      var x1 = 'nav-link' + classNameHover + editingClass;
      
      i1 = <div className={x1} href="#" style={allStyles1} onClick={clickNavItem(anItemKey)} onMouseOver={actHoveringWhere(thisItemPathString)} onMouseOut={actHoveringWhere('')}>{text2}</div>

      // <span className={'nav-link' + editingClass} style={allStyles1} onClick={clickNavItem(anItemKey)} onMouseOver={actHoveringWhere(thisItemPathString)} onMouseOut={actHoveringWhere('')}>{text2}</span></li>
//
    }else if (anItem.t === 'navDropDown'){
      var text3 = allStyles1.text;
      if (!text3){
        text3 = '';
      }else if (typeof text3 === 'object'){
        text3 = 'Error';
      }
      var insides = doASet(organicChanges, anItem.i, 'i', interactionFn, upwardInfo, thisItemPath, itemEdited, setItemEdited, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, errorString, hoveringWhere, actHoveringWhere, changeTab, tabSelected, isShowingSomeDropDown, 'Dropdown', true, classNameHover, doAScreenRef, flashHighlight);
      StyleFunctions.expandBIU(allStyles1);
      allStyles1.cursor = 'pointer';

      var allStyles2 = StyleFunctions.evaluateStyleR('navDropDownMenu', anItem.s, thisItemPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      allStyles2.backgroundColor = allStyles2.menuBackgroundColor;
      allStyles2.cursor = 'pointer';
      if (!allStyles2.specWidth){
        delete allStyles2.width;
      }

     return <div className={'nav-item dropdown' + editingClass} onClick={clickNavItem(anItemKey)} onMouseOver={actHoveringWhere(thisItemPathString)} onMouseOut={actHoveringWhere('')}>
                        <div className='nav-link dropdown-toggle' style={allStyles1} >{text3}</div>
                        <ul className="dropdown-menu" style={allStyles2}>
                          {insides}
                        </ul>
                        </div>

//
      // return <span className={'nav-link' + editingClass} >Drop {text2}</span>
//
    }else if (anItem.t === 'IMG'){

      i1 = <NavImage editingClass={editingClass} allStyles1={allStyles1} clickNavItem={clickNavItem} actHoveringWhere={actHoveringWhere} doAScreenRef={doAScreenRef} itemPath={navBarPath} anItemKey={anItemKey} />

//      
    }else if (anItem.t === 'BUTTON'){

//  
      i1 = <Button isError={isError} doAScreenRef={doAScreenRef} itemPath={navBarPath} allStyles={allStyles1} stylesToAdd={{marginLeft:'1px', marginRight:'1px'}} addClasses={editingClass} interactionFn={interactionFn} clickFn={clickNavItem(anItemKey)} draggable={false} onDragStart={false} onDragEnd={false} onDrag={false} onMouseOver={actHoveringWhere(navBarPath.join(' '))} onMouseOut={actHoveringWhere('')} />

//
    }else if (anItem.t === 'CONTAINER'){
      console.warn(anItem);
      return null;

    }else{
      function clickUp(e){
        var changes = [{t:'r', w:navBarPath.concat([pointer]), i:anItemKey}];
        organicChanges(changes);
      }

      return <div onClick={clickUp}>Funky Problem</div>
      // console.warn(anItem);
      // return null;
    }

    if (coverState){
      return <li className='nav-item'>{i1}</li>
//
    }else{
      return i1;
    }
//
  })
//
  if (navItems.length === 0 && setItemEdited){
      function addNavBarItem(e){
        changeTab('AddElement', 0);
      }
      var txt = 'Empty ' + title + '. Click to add.';
      if (tabSelected && tabSelected.t === 'AddElement' && !isShowingSomeDropDown){
        txt = 'Empty ' + title + '. Select element from the left bar.';
      }
      return [<a onClick={addNavBarItem}  style={{padding:'5px'}}>{txt}</a>]
    
  }else{
    return navItems;
  }
//
//

}
export default App;